import {
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';

export const cultureInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const currentCulture = inject(TranslocoService).getActiveLang();


    const modifiedReq = req.clone({
        setHeaders: {
            'Accept-Language': currentCulture
        }
    });

    return next(modifiedReq);
};
